import { createStandardAction } from 'typesafe-actions';

export type UpdateEntitiesPayload = {
  [key: string]: any;
};

const updateEntities = createStandardAction('updateEntities')<UpdateEntitiesPayload>();

export default updateEntities;
